import { styled } from "styled-components";
import { Button, Modal, Typography } from "antd";
import { useEffect } from "react";
import { TRACKING } from "config/consts";
import { useApp } from "contexts/AppProvider";

const StyledHelp = styled.div`
  // position: fixed;
  background: white;
  // z-index: 3;
  // top: 0;
  // bottom: 0;
  // left: 0;
  // right: 0;
  // display: flex;
  // justify-content: center;
  // align-items: center;
  // flex-direction: column;
  padding: 20px 0 0;
  // overflow: scroll;
  // transition: all 0.3s ease-in-out;
`;

export const ServiceHint = ({ showHelp, setShowHelp, locale }) => {
  const { setActiveStep, services } = useApp();

  useEffect(() => {
    if (showHelp) {
      setActiveStep(TRACKING.HINTS);
    }
  }, [showHelp]);

  return (
    <Modal open={showHelp} onCancel={() => setShowHelp(false)} footer={null} width={800}>
      <StyledHelp>
        <div>
          {(services || [])
            .filter((service) => service.descriptions[locale])
            .map((service) => (
              <div key={service.id} style={{ marginBottom: 20 }}>
                <Typography.Text>
                  <strong>{service.translations[locale]}</strong>
                </Typography.Text>
                <br />
                <Typography.Text>{service.descriptions[locale]}</Typography.Text>
              </div>
            ))}

          <Button type="default" onClick={() => setShowHelp(false)}>
            {locale === "pl" ? "Zamknij" : "Close"}
          </Button>
        </div>
      </StyledHelp>
    </Modal>
  );
};
